import { z } from 'zod';
import { IsoDateTimeSchema } from './common.js';
export const DesignRequestKindSchema = z.enum([
    'menu_board',
    'promotion',
    'opening_hours',
    'welcome_screen',
    'other',
]);
export const DesignRequestOrientationSchema = z.enum(['landscape', 'portrait']);
export const DesignRequestStatusSchema = z.enum(['sent', 'designing', 'review', 'live']);
export const DESIGN_REQUEST_KIND_LABELS = {
    menu_board: 'Menu board',
    promotion: 'Promotion',
    opening_hours: 'Opening hours',
    welcome_screen: 'Welcome screen',
    other: 'Something else',
};
export const DesignProofLineSchema = z.object({
    name: z.string(),
    price: z.string(),
});
export const DesignProofSchema = z.object({
    bg: z.string().min(1),
    fg: z.string().min(1),
    head: z.string(),
    sub: z.string(),
    lines: z.array(DesignProofLineSchema),
    photoMediaAssetId: z.string().min(1).nullable(),
});
export const DesignAttachmentSchema = z.object({
    filename: z.string().min(1).max(300),
    mediaAssetId: z.string().min(1).nullable(),
});
export const CreateDesignRequestSchema = z.object({
    kind: DesignRequestKindSchema,
    description: z.string().min(1).max(8000),
    orientation: DesignRequestOrientationSchema.default('landscape'),
    screenIds: z.array(z.string().min(1)).max(200).default([]),
    attachments: z.array(DesignAttachmentSchema).max(40).default([]),
});
export const RequestDesignChangesSchema = z.object({
    changeRequest: z.string().min(1).max(4000),
});
export const DesignRequestSchema = z.object({
    id: z.string().min(1),
    organisationId: z.string().min(1),
    title: z.string().min(1),
    kind: DesignRequestKindSchema,
    description: z.string(),
    orientation: DesignRequestOrientationSchema,
    status: DesignRequestStatusSchema,
    changeRequest: z.string(),
    revision: z.number().int().nonnegative(),
    proof: DesignProofSchema.nullable(),
    attachments: z.array(DesignAttachmentSchema),
    screenIds: z.array(z.string().min(1)),
    approvedAt: IsoDateTimeSchema.nullable(),
    createdAt: IsoDateTimeSchema,
    updatedAt: IsoDateTimeSchema,
});
//# sourceMappingURL=design-request.js.map